<template>
  <div style="display:inline-block;">
    <span v-if="dateJudge(subscriptionItem.startDate, subscriptionItem.endDate) == 0">--</span>
    <span
      class="rowStatus-text-status"
      v-if="dateJudge(subscriptionItem.startDate, subscriptionItem.endDate) == 1"
      >未開始 ({{ subscriptionItem.endDate | formatDate }} 完結)</span
    >
    <span
      class="rowStatus-text-subscribing"
      v-if="dateJudge(subscriptionItem.startDate, subscriptionItem.endDate) == 2"
      >訂閱中 ({{ subscriptionItem.endDate | formatDate }} 完結)</span
    >
    <span
      class="rowStatus-text-status"
      v-if="dateJudge(subscriptionItem.startDate, subscriptionItem.endDate) == 3"
      >即將過期 ({{ subscriptionItem.endDate | formatDate }} 完結)</span
    >
    <span v-if="dateJudge(subscriptionItem.startDate, subscriptionItem.endDate) == 4"
      >到期 ({{ subscriptionItem.endDate | formatDate }} 完結)</span
    >
    <span v-if="dateJudge(subscriptionItem.startDate, subscriptionItem.endDate) == 5"
      >過期 ({{ subscriptionItem.endDate | formatDate }} 完結)</span
    >
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    subscriptionItem: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getThreeMonthAgo(endDate) {
      var a = moment();
      var b = moment(endDate);
      return b.diff(a, "months");
    },
    dateJudge(startDate, endDate) {
      let status = 0;
      let startDates = moment(startDate).format("YYYY-MM-DD");
      let endDates = moment(endDate).format("YYYY-MM-DD");
      let nowDate = moment().format("YYYY-MM-DD");
      if (nowDate < startDates) {
        // status = 1;
        return (status = 1);
      } else if (nowDate == endDates) {
        // status = 4;
        return (status = 4);
      } else if (nowDate > endDates) {
        // status = 5;
        return (status = 5);
      } else if (this.getThreeMonthAgo(endDate) <= 3 && nowDate >= startDates) {
        // status = 3;
        return (status = 3);
      } else if (nowDate >= startDates && nowDate < endDates) {
        // status = 2;
        return (status = 2);
      }
      return status;
    },
  },
};
</script>

<style lang="scss" scoped>
.rowStatus-text-subscribing {
  color: #399500;
}
.rowStatus-text-status {
  color: #ff0000;
}
</style>